import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

import { ExcludedMno } from '@/apis/core/types';

interface MnoExclusionRowProps {
  mno: ExcludedMno;
  onRemove?: () => void;
}

const MnoExclusionRow: FunctionComponent<MnoExclusionRowProps> = ({
  mno,
  onRemove,
}) => (
  <Flex
    sx={{
      flexDirection: 'row',
      fontWeight: 400,
    }}
  >
    <Box
      sx={{
        padding: '11px 0 11px 16px',
        color: '#101820',
        fontSize: 'H300',
        lineHeight: 'normal',
      }}
    >
      {mno.name}
    </Box>
    <Box
      sx={{
        padding: '11px 8px',
        color: 't.blue100',
        fontSize: 'H300',
        lineHeight: 'normal',
        cursor: 'pointer',
        textDecoration: 'underline',
      }}
      onClick={onRemove}
    >
      Remove Exclusion
    </Box>
  </Flex>
);

export default MnoExclusionRow;
